import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactFileReader from "react-file-reader";
import { useGetAvailableLanguages, useSelectLanguage } from '../../hooks/global/Languages';
import { downloadInvitationTemplate, parseInvitationCsv, validateAndJoinInvitationsByUser, downloadProfilesAndProductsList, } from "../../helpers/csvFileHelpers";
import { useGetCurrentVendor, useGetVendorId } from '../../hooks/global/User';
import CreateBatchSender from "./CreateBatchSender";
import { useGetVendor } from '../../hooks/vendors/Vendors';

const BatchSendingForm = ({ profiles, groups, companyId }) => {

    const { t, i18n } = useTranslation();


    const products = groups.flatMap(group =>
        group.products.map(product => ({
          ...product,
          group_id: group.id
        }))
      );

    const vendorId = useGetVendorId();
    const vendor = useGetCurrentVendor();
    const availableLanguages = useGetAvailableLanguages();

    const [importedInvitations, setImportedInvitations] = useState();
    const [isFile, setIsFile] = useState(false);
    const [validationMessage, setValidationMessage] = useState("");
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const { selectTextByLanguage } = useSelectLanguage();

    const validateImportedInvitations = (invitations) => {
        if (invitations.length === 0) {
            setValidationMessage(t("err.zeroInv"));
        } else if (invitations.length > 1000) {
            setValidationMessage(t("err.invLong"));
        }
    };

    const uploadInvitationCsv = (files) => {
        setImportedInvitations(undefined);

        if (!files) return;

        if (!files[0].name.endsWith(".csv")) {
            setShowErrorMessage(true);
            setErrorMessage(t("err.wrFile"));
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const arrayBuffer = e.target.result;
                let decoder = new TextDecoder('UTF-8');
                let rows = decoder.decode(arrayBuffer);

                // Check for replacement character to indicate potential misinterpretation
                if (rows.includes('\uFFFD')) {
                    console.log('Detected replacement characters, retrying with windows-1252');
                    decoder = new TextDecoder('windows-1252');
                    rows = decoder.decode(arrayBuffer);
                }
                parseInvitationCsv(rows, (invitationRows) => {
                    let invitations = validateAndJoinInvitationsByUser(invitationRows, products, groups, profiles, vendorId, companyId, availableLanguages, availableLanguages, t);

                    setIsFile(true);

                    if (!invitations) return;

                    setImportedInvitations(invitations);
                    validateImportedInvitations(invitations);
                });
            } catch (error) {
                console.error('Error processing file:', error);
                setShowErrorMessage(true);
                setErrorMessage(t("err.wrFile"));
            }
        };

        reader.onerror = () => {
            console.error('FileReader error:', reader.error);
            setShowErrorMessage(true);
            setErrorMessage(t("err.wrFile"));
        };

        // Read the file as an ArrayBuffer
        reader.readAsArrayBuffer(files[0]);
    };

    const removeImportedInvitation = (invitationEmail, profileId) => {
        let newInvitationsList = [...importedInvitations];
        let inviteToKeep = newInvitationsList.filter(
            (invite) =>
                !(
                    invite.customerEmail === invitationEmail &&
                    invite.profileId === profileId
                )
        );
        setImportedInvitations(inviteToKeep);
    };

    const notifyError = (err) => {
        setErrorMessage(err);
        showErrorMessage(true);
    };



    return (<>
        <h2 className="header-class">{t('admin.inv.bat')}</h2>

        <div className="description-and-controls">

            <ul className="instructionsList">
                <li>
                    {t("admin.inv.tmpU")}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="link link-csvDownload" href="#" onClick={() => downloadInvitationTemplate(availableLanguages, t)} >
                        &nbsp;{t("admin.common.here")}
                    </a>
                    .
                </li>
                <li>
                    {t("admin.inv.ele")}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="link link-csvDownload" href="#" onClick={() =>
                        downloadProfilesAndProductsList(groups, profiles, products, vendor, availableLanguages, t, i18n.language, selectTextByLanguage)}
                    >
                        &nbsp;{t("admin.common.here")}
                    </a>
                    .
                </li>
                <li>{t("admin.inv.csv")}</li>
            </ul>

            <ReactFileReader handleFiles={uploadInvitationCsv} fileTypes={".csv"}>
                <p>
                    {t("admin.inv.inU")} <br />
                    <button className="btn btn-default btn-send btn btn-primary" title={t("admin.inv.upl")}>
                        {t("admin.inv.upl")}
                    </button>
                </p>
            </ReactFileReader>
        </div>

        <div>
            <p>
                <strong>{t("admin.inv.recInv")}</strong>
            </p>
            <CreateBatchSender
                profiles={profiles}
                vendor={vendor}
                importedInvitations={importedInvitations}
                notifyError={notifyError}
                removeImportedInvitation={removeImportedInvitation}
                uploadInvitations={uploadInvitationCsv}
            />
        </div>
    </>
    );
};

export default BatchSendingForm;